 //const API="https://databotbackend.herokuapp.com"
 //const API="https://d19aruoimdl4e5.cloudfront.net"
 //const API="http://localhost:5000"
 //const API="http://covidinfo-env.eba-cj99cpg3.us-east-1.elasticbeanstalk.com"
  const API="https://d29k9ox6t4dul7.cloudfront.net"


 export default API;